import { create } from 'zustand';
import ApiService from '../services/ApiService';

const useBillingStore = create((set, get) => ({
  billingInfo: null,
  loading: false,
  error: null,
  fetchBillingInfo: async () => {
    if (get().billingInfo) return; // Data already fetched
    set({ loading: true, error: null });
    try {
      const data = await ApiService.getBillingUsage();
      set({ billingInfo: data, loading: false });
    } catch (error) {
      console.error('Error fetching billing info:', error);
      set({ error, loading: false });
    }
  },
}));

export default useBillingStore;
